import * as React from 'react';
import {
  CardContainer,
  HeaderContainer,
  FooterContainer,
  CardDescription,
  CardTitle,
  OtherPortalsLink,
  FooterDivider,
} from '../../Common/Styles/otherPortals.styled';

export function DocumentationCard(): React.ReactElement {
  return (
    <>
      <CardContainer>
        <HeaderContainer>
          <CardTitle>Documentation</CardTitle>
          <CardDescription>
            This documentation helps you better understand the HR Data Platform and how to publish / consume data.
          </CardDescription>
        </HeaderContainer>

        <FooterDivider />

        <FooterContainer>
          <OtherPortalsLink
            to="https://eng.ms/docs/office-of-coo/microsoft-digital/human-resources/hr-experiences/hr-data-platform/hr-data-platform/onboarding/getting-started"
            title=""
            target="_blank"
            usageEvent={{
              feature: 'HRDP',
              subFeature: 'HRDP.Home.Documentation.EngHub',
            }}
          >
            Engineering Hub
          </OtherPortalsLink>
        </FooterContainer>
      </CardContainer>
    </>
  );
}

export function SupportChannelCard(): React.ReactElement {
  return (
    <>
      <CardContainer>
        <HeaderContainer>
          <CardTitle>HRDP - Support Channel</CardTitle>
          <CardDescription>
            This Teams channel is equipped with 1ESChat, which can answer FAQs from our most recent documentation.
          </CardDescription>
        </HeaderContainer>

        <FooterDivider />

        <FooterContainer>
          <OtherPortalsLink
            to="https://teams.microsoft.com/l/channel/19%3A35f9ccab3d484aa6a9a2c6a6dcf29cab%40thread.tacv2/HRDP%20-%20Support%20Channel?groupId=e05437e0-b9e1-404e-89b3-55508721982e&tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47"
            title=""
            target="_blank"
            usageEvent={{
              feature: 'HRDP',
              subFeature: 'HRDP.Home.SupportChannel.Teams',
            }}
          >
            HRDP - Support Channel
          </OtherPortalsLink>
        </FooterContainer>
      </CardContainer>
    </>
  );
}

export function AnnouncementsCard(): React.ReactElement {
  return (
    <>
      <CardContainer>
        <HeaderContainer>
          <CardTitle>Announcements</CardTitle>
          <CardDescription>
            Stay in the loop! Follow HRDP Announcements for real-time updates on incidents, deployments, upcoming
            changes, and new features.
          </CardDescription>
        </HeaderContainer>

        <FooterDivider />

        <FooterContainer>
          <OtherPortalsLink
            to="https://teams.microsoft.com/l/channel/19%3Aa41d8ee583b64c50a6afe4f450f13f64%40thread.tacv2/Announcements?groupId=e05437e0-b9e1-404e-89b3-55508721982e&tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47"
            title=""
            target="_blank"
            usageEvent={{
              feature: 'HRDP',
              subFeature: 'HRDP.Home.Announcements.Teams',
            }}
          >
            HRDP - Announcements
          </OtherPortalsLink>
        </FooterContainer>
      </CardContainer>
    </>
  );
}
